import React, { useContext, useState } from 'react';
import { AutoComplete, AutoCompleteProps } from 'antd';
import { ContractType } from '@/config';
import { renderIntlLabel } from '@/utils';
import IntlContext from '../Intl/IntlContext';

const EMAIL_DOMAIN_LIST = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'icloud.com',
  'live.com',
  'qq.com',
  '163.com',
  'sina.com',
  '126.com',
  'foxmail.com',
  'sohu.com',
];

export const EMAIL_REG = /^(?=.+@)(?=.+@[0-9a-zA-Z_]+\..+)[0-9a-zA-Z_.@]{5,100}$/;

interface BaseEmailInputProps extends AutoCompleteProps {
  isKeyPerson: boolean;
  value: string;
  onChange: (val: string) => void;
}
const BaseEmailInput: React.FC<Partial<BaseEmailInputProps>> = ({
  isKeyPerson = true,
  value,
  onChange,
  ...rest
}) => {
  const { TenantSysConfig } = useContext(IntlContext);

  // const [status, setStatus] = useState<'error' | 'warning' | ''>();
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  // const updateErrorStatus = (val) => {
  //   if (!MAIL_REG.test(val)) {
  //     // message.error('仅支持字母、数字、点号“.”和下划线“_”，100字符以内');
  //     setStatus('error');
  //   } else {
  //     setStatus('');
  //   }
  // };

  const handleSearch = (val: string) => {
    // updateErrorStatus(val);

    let res: { value: string; label: string }[];
    if (!val) {
      res = [];
    } else if (val.indexOf('@') >= 0) {
      const list = val.split('@');
      res = EMAIL_DOMAIN_LIST.filter((domain) => domain.includes(list?.[1])).map((domain) => ({
        value: `${list?.[0]}@${domain}`,
        label: `${list?.[0]}@${domain}`,
      }));
    } else {
      res = EMAIL_DOMAIN_LIST.map((domain) => ({
        value: `${val}@${domain}`,
        label: `${val}@${domain}`,
      }));
    }
    setOptions(res);
  };

  const handleChange = (data: string) => {
    // updateErrorStatus(data);

    if (onChange) {
      onChange(data);
    }
  };

  return (
    <>
      <AutoComplete
        // getPopupContainer={(triggerNode) => triggerNode.parentElement}
        placeholder={
          isKeyPerson && TenantSysConfig?.contractType === ContractType.EMAIL
            ? renderIntlLabel('app_required')
            : renderIntlLabel('app_optional')
        }
        options={options}
        value={value}
        onSearch={handleSearch}
        onChange={handleChange}
        style={{ minWidth: 320, maxWidth: 380 }}
        maxLength={100}
        // status={status}
        {...rest}
      />
    </>
  );
};

export default BaseEmailInput;
